<template>
  <div class="my-rewards-wrapper">
    <DialogPopup
      :show="value"
      width="470px"
      :append-to-body="true"
    >
      <MyRewards @icon-click="close" />
    </DialogPopup>
  </div>
</template>

<script>
import DialogPopup from '@/components/DialogPopup'
import MyRewards from './index.vue'

export default {
  name: 'MyRewardsDialog',
  components: {
    DialogPopup,
    MyRewards,
  },
  props: {
    value: Boolean
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$emit('input', false);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>